import type { ReviewItem } from '@shared/api';

/**
 * Resolved review items never render — not in page badges or status copy.
 * This is the one place that decides "open," so every review affordance
 * agrees.
 */
export interface OpenReviewCounts {
  open: ReviewItem[];
  required: number;
  suggestions: number;
}

export function openReviewCounts(reviewItems: ReviewItem[]): OpenReviewCounts {
  const open = reviewItems.filter((item) => item.state === 'open');
  const required = open.filter((item) => item.severity === 'required').length;
  const suggestions = open.filter((item) => item.severity === 'warning').length;
  return { open, required, suggestions };
}

/**
 * Open review work attached to one slide, with blockers before suggestions.
 * The original order is otherwise preserved so repeated clicks never shuffle
 * the question the seller sees.
 */
export function openReviewItemsForPage(reviewItems: ReviewItem[], pageId: string): ReviewItem[] {
  return reviewItems
    .filter((item) => item.state === 'open' && item.pageIds.includes(pageId))
    .map((item, index) => ({ item, index }))
    .sort((a, b) => {
      const severity = Number(b.item.severity === 'required') - Number(a.item.severity === 'required');
      return severity || a.index - b.index;
    })
    .map(({ item }) => item);
}
